<template>
  <div>
    <object
      id="av-player"
      type="application/avplayer"
      class="video"
      ref="player"
      @click="showGUI"
    ></object>
    <div>
      <div
        v-show="jump == 'left'"
        class="seek-left"
        :style="{
          backgroundImage: 'url(' + require('@/assets/oval-ic.png') + ')',
        }"
      >
        <div class="seek-term left">-{{ seekTerm }}</div>
        <img class="seek-ic left" src="@/assets/ic-left.png" />
      </div>
      <div
        v-show="jump == 'right'"
        class="seek-right"
        :style="{
          backgroundImage: 'url(' + require('@/assets/oval-ic.png') + ')',
        }"
      >
        <div class="seek-term">+{{ seekTerm }}</div>
        <img class="seek-ic" src="@/assets/ic-right.png" />
      </div>
    </div>
    <transition name="slide-fade">
      <div v-if="show">
        <div @click="enterKeyProc" @mouseover="moveFocus(0)">
          <img
            v-if="focusIndex === 0"
            class="back"
            src="@/assets/vod-retrun-ic-f.png"
          />
          <img v-else class="back" src="@/assets/vod-retrun-ic-u.png" />
        </div>
        <template v-if="!isLive">
          <div @click="enterKeyProc" @mouseover="moveFocus(1)">
            <img
              v-if="focusIndex === 1"
              class="restart"
              src="@/assets/vod-before-ic-f.png"
            />
            <img v-else class="restart" src="@/assets/vod-before-ic-u.png" />
          </div>
        </template>
      </div>
    </transition>
    <transition name="slide-fade">
      <div v-if="show" class="pb-area">
        <div class="play-time">
          <span>{{ computedPlayPosition }}</span
          ><span v-if="!isLive">{{ computedPlayTime }}</span>
        </div>
        <div class="progressbar">
          <div class="innerbar" :style="innerBarStyle"></div>
          <div
            class="indicator"
            :style="indicatorStyle"
            @mousedown="mouseDragOn"
            @mouseup="mouseDragOff"
            v-show="mouseActivated"
          >
            <img src="@/assets/ball-indicator.png" />
          </div>
        </div>
        <div @click="enterKeyProc" @mouseover="moveFocus(2)">
          <template v-if="isPlaying">
            <img
              v-if="focusIndex === 2"
              class="play-pause pause"
              src="@/assets/stop-ic-f.png"
            />
            <img v-else class="play-pause pause" src="@/assets/stop-ic-u.png" />
          </template>
          <template v-else>
            <img
              v-if="focusIndex === 2"
              class="play-pause pause"
              src="@/assets/play-f.png"
            />
            <img v-else class="play-pause pause" src="@/assets/play-u.png" />
          </template>
        </div>
      </div>
    </transition>
    <div v-if="showPopup" class="exit-popup">
      <div class="dim"></div>
      <p class="pupup-message"> 홈 화면으로 이동합니다. </p>
      <button
        :class="{ focused: popupFocusIndex === 0 }"
        @click="historyBack"
        @mouseover="popupFocusIndex = 0"
        ref="button"
      >
        확인
      </button>
      <button
        :class="{ focused: popupFocusIndex === 1 }"
        @click="backKeyProc"
        @mouseover="popupFocusIndex = 1"
        ref="button"
      >
        취소
      </button>
    </div>
    <div class="movingboard" v-if="dragMode" @mouseup="mouseDragOff">
      <div
        class="active-area"
        @mouseup="mouseDragOff"
        @mousemove="mouseMove"
      ></div>
    </div>
  </div>
</template>

<script>
import * as deviceApi from "../api/smartTv.js"
import PlayerMixin from "../mixins/player.mixin"

export default {
  name: 'avplayer',
  mixins: [PlayerMixin],
  props: ["vodId", "contentType"],
  data() {
    return {
      isActiveVue: true,
      focusIndex: 2,
      popupFocusIndex: 1,
      show: false,
      setVodComplete: false,
      isPlaying: true,
      isBuffering: false,
      playPostion: 0,
      playTime: 0,
      showPopup: false,
      dragMode: false,
      progressBarX: 0,
      indicatorX: 0,
      seekTerm: 5,
      jump: false,
      logStartTime: null,
      guiTimer: null,
      playInterval: null,
      logInterval: null,
      jumpIconTimer: null,
      popupTimer: null,
      playerCoords: {
        x: 0,
        y: 0,
        width: 1920,
        height: 1080,
      },
    };
  },

  computed: {
    isLive() {
      return this.contentType == "live"
    },
    userInfo() {
      return this.$store.getters.userInfo;
    },
    lambdaInfo() {
      return this.$store.getters.lambdaInfo;
    },
    keyInput() {
      return this.$store.getters.keyInput;
    },
    mouseActivated() {
      return this.$store.getters.mouseActivated;
    },
    player() {
      return this.$refs.player;
    },
    source() {
      return this.$refs.source;
    },
    computedPlayPosition() {
      return this.convertTimeString(this.playPostion);
    },
    computedPlayTime() {
      return " / " + this.convertTimeString(this.playTime);
    },
    innerBarStyle() {
      return {
        width: this.progressBarX + "px",
      };
    },
    indicatorStyle() {
      return {
        left: this.indicatorX + "px",
      };
    },
    logViewApi() {
      return this.lambdaInfo.a_view;
    },
    logData() {
      return {
        age: this.userInfo.age,
        gender: this.userInfo.gender,
        os: deviceApi.getOsType() == "lg" ? "4" : "5",
        start: this.logStartTime,
        type: this.isLive ? "L" : "V",
        subType: this.userInfo.subType,
        serviceId: this.userInfo.serviceId,
        userId: this.userInfo.userId,
        videoId: this.vodId,
      };
    },
  },

  watch: {
    keyInput(val, oldVal) {
      if (this.isActiveVue) {
        switch (val.key) {
          case "ArrowUp":
            this.upKeyProc(val);
            break;
          case "ArrowDown":
            this.downKeyProc(val);
            break;
          case "ArrowLeft":
            this.leftKeyProc(val);
            break;
          case "ArrowRight":
            this.rightKeyProc(val);
            break;
          case "Enter":
            this.enterKeyProc(val);
            break;
          case "MediaPlayPause":
            this.playPauseKeyProc(val);
            break;
          case "Backspace":
            this.backKeyProc(val);
            return;
          default:
            return;
        }

        // if (this.showPopup == false) {
        //   this.showGUI();
        // }
      }
    },
    showPopup(val, oldVal) {
      if (val == true) {
        this.hideGUI();
        this.popupTimer = setTimeout(() => {
          this.showPopup = false;
        }, 60000);
      } else {
        this.clearPopupTimer();
      }
    },
  },

  methods: {
    upKeyProc(keyInput) {
      if (this.showPopup == false) {
        if (this.show == true) {
          switch (this.focusIndex) {
            case 2:
              this.focusIndex = 0;
              break;
          }
        }
        this.showGUI();
      }
    },
    downKeyProc(keyInput) {
      if (this.showPopup == false) {
        if (this.show == true) {
          switch (this.focusIndex) {
            case 0:
            case 1:
              this.focusIndex = 2;
              break;
          }
        }
        this.showGUI();
      }
    },
    leftKeyProc(keyInput) {
      if (this.showPopup === true) {
        this.popupFocusIndex = Math.abs(this.popupFocusIndex - 1);
        this.resetPopupTimer();
      } else {
        if (!this.isLive) {
          switch (this.focusIndex) {
            case 0:
              this.focusIndex = 1;
              break;
            case 1:
              this.focusIndex = 0;
              break;
            case 2:
              if (this.isPlaying && !this.isBuffering) {
                this.seekTerm = 5;
                this.rew(this.seekTerm);
                this.showJumpIcon("left");
              }
              break;
          }
        }
        this.showGUI();
      }
    },
    rightKeyProc(keyInput) {
      if (this.showPopup === true) {
        this.popupFocusIndex = Math.abs(this.popupFocusIndex - 1);
        this.resetPopupTimer();
      } else {
        if (!this.isLive) {
          switch (this.focusIndex) {
            case 0:
              this.focusIndex = 1;
              break;
            case 1:
              this.focusIndex = 0;
              break;
            case 2:
              if (this.isPlaying && !this.isBuffering) {
                this.seekTerm = 5;
                this.ff(this.seekTerm);
                this.showJumpIcon("right");
              }
              break;
          }
        }
        this.showGUI();
      }
    },
    enterKeyProc(keyInput) {
      if (this.showPopup === true) {
        switch (this.popupFocusIndex) {
          case 0:
            this.historyBack();
            break;
          case 1:
            this.showPopup = false;
            break;
        }
      } else {
        if (this.show == true) {
          switch (this.focusIndex) {
            case 0:
              this.backKeyProc();
              break;
            case 1:
              this.restart();
              break;
            case 2:
              this.playPause();
              break;
          }
        }
        this.showGUI();
      }
    },
    playPauseKeyProc(keyInput) {
      if (this.showPopup == false) {
        this.playPause();
        this.showGUI();
      }
    },
    backKeyProc(keyInput) {
      this.showPopup = !this.showPopup;
      this.hideGUI();
    },

    moveFocus(index) {
      this.showGUI();
      this.focusIndex = index;
    },

    historyBack() {
      this.stop();
      this.$router.go(-1);
    },
    mouseDragOn() {
      this.dragMode = true;
    },
    mouseDragOff() {
      this.dragMode = false;
      this.player.currentTime = (this.playTime * this.indicatorX) / 1680;
      this.showGUI();
    },
    mouseMove(e) {
      this.indicatorX = e.offsetX;
    },

    start: function (url) {
      console.log("Starting playback");

      const self = this;
      const listener = {
        onbufferingstart: function () {
          console.log("Buffering start.");
          self.$progress.$emit("on:progress");
          // self.isBuffering = true;
        },
        // onbufferingprogress: function (percent) {
        //   console.log("Buffering progress data : " + percent);
        // },
        onbufferingcomplete: function () {
          console.log("Buffering complete.");
          self.$progress.$emit("off:progress");
          // self.isBuffering = false;
          self.playTime = webapis.avplay.getDuration() / 1000;
        },
        oncurrentplaytime: function (currentTime) {
          self.setPlayPostion(currentTime);
        },
        onevent: function (eventType, eventData) {
          console.log("event type: " + eventType + ", data: " + eventData);
        },
        onstreamcompleted: function () {
          console.log("Stream Completed");
          self.historyBack();
        },
        onerror: function (eventType) {
          console.log("event type error : " + eventType);
          self.onErrorEvent(eventType);
        },
      };

      try {
        // const bitRateString =
        //   "BITRATES=5000~10000|STARTBITRATE=HIGHEST|SKIPBITRATE=LOWEST";
        // webapis.avplay.setStreamingProperty("ADAPTIVE_INFO", bitRateString);
        webapis.avplay.open(url);
        webapis.avplay.setDisplayRect(
          this.playerCoords.x,
          this.playerCoords.y,
          this.playerCoords.width,
          this.playerCoords.height
        );
        webapis.avplay.setListener(listener);
      } catch (e) {
        console.log(e);
      }

      webapis.avplay.prepare();
      // webapis.avplay.play();
      this.play(true);
    },

    onErrorEvent(errorCode) {
      this.clearAllTimer();
      this.$router.replace({
        name: "err-api",
        params: {
          errorCode: errorCode,
        },
      });
    },

    playPause() {
      if (webapis.avplay.getState() === "PAUSED") {
        this.play(true);
      } else {
        this.pause();
      }
    },

    play(sendLog) {
      console.log("VOD Playing!!!");
      this.$progress.$emit("off:progress");
      this.isPlaying = true;
      webapis.avplay.play();

      if (sendLog) {
        this.sendViewLog();
      }
    },

    pause() {
      webapis.avplay.pause();
      this.isPlaying = false;
      this.clearLogInterval();
    },

    stop() {
      this.$progress.$emit("off:progress");
      this.clearAllTimer();
      webapis.avplay.stop();
    },

    restart() {
      webapis.avplay.seekTo(1);
    },

    ff(sec) {
      const self = this;
      this.isBuffering = true;
      webapis.avplay.jumpForward(
        sec * 1000,
        function () {
          console.log("jumpForward success");
          self.isBuffering = false;
        },
        function () {
          console.log("jumpForward failed");
          self.isBuffering = false;
        }
      );
    },

    rew(sec) {
      const self = this;
      this.isBuffering = true;
      webapis.avplay.jumpBackward(
        sec * 1000,
        function () {
          console.log("jumpBackward success");
          self.isBuffering = false;
        },
        function () {
          console.log("jumpBackward failed");
          self.isBuffering = false;
        }
      );
    },

    setPlayPostion(currentTime) {
      this.playPostion = currentTime / 1000;

      if (this.isLive) {
        this.progressBarX = 1680;
      } else {
        this.progressBarX = (this.playPostion / this.playTime) * 1680;
      }
      if (!this.dragMode) {
        this.indicatorX = this.progressBarX;
      }
    },

    showGUI() {
      this.clearGuiTimer();
      this.show = true;
      this.guiTimer = setInterval(() => {
        if (this.dragMode === false) {
          this.hideGUI();
          this.hideJumpIcon();
        }
      }, 5000);
    },

    hideGUI() {
      this.clearGuiTimer();
      this.show = false;
      this.focusIndex = 2;
    },

    showJumpIcon(dirction) {
      this.jump = dirction;

      clearTimeout(this.jumpIconTimer);
      this.jumpIconTimer = null;

      this.jumpIconTimer = setTimeout(() => {
        this.hideJumpIcon();
      }, 5000);
    },

    hideJumpIcon() {
      clearTimeout(this.jumpIconTimer);
      this.jumpIconTimer = null;
      this.jump = false;
    },

    resetPopupTimer() {
      this.clearPopupTimer();
      this.popupTimer = setTimeout(() => {
        this.showPopup = false;
      }, 60000);
    },

    convertTimeString(sec) {
      let min = parseInt((sec % 3600) / 60);
      let second = parseInt(sec % 60);
      if (Number.isNaN(min) || Number.isNaN(second)) {
        return "0:00:00";
      }

      if (min < 10) {
        min = "0" + min;
      }
      if (second < 10) {
        second = "0" + second;
      }
      return parseInt(sec / 3600) + ":" + min + ":" + second;
    },

    sendViewLog() {
      if (this.userInfo.userId == undefined) {
        console.log("invalid user");
        return;
      }

      const sender = (_data) => {
        this.$store
          .dispatch("SEND_VIEW_LOG", {
            url: this.logViewApi,
            data: _data,
          })
          .then((response) => {
            if (response.data) {
              this.logStartTime = response.data;
            }
          });
      };

      this.logStartTime = null;
      this.clearLogInterval();

      sender(this.logData);

      this.logInterval = setInterval(() => {
        sender(this.logData);
      }, 60 * 1000);
    },

    clearLogInterval() {
      clearInterval(this.logInterval);
      this.logInterval = null;
    },

    clearPlayInterval() {
      clearInterval(this.playInterval);
      this.playInterval = null;
    },

    clearGuiTimer() {
      clearTimeout(this.guiTimer);
      this.guiTimer = null;
    },

    clearPopupTimer() {
      clearTimeout(this.popupTimer);
      this.popupTimer = null;
    },

    clearAllTimer() {
      this.clearPlayInterval();
      this.clearLogInterval();
      this.clearGuiTimer();
      this.clearPopupTimer();
      this.hideJumpIcon();
    }
  },

  created() {
    this.manifestLoader(this.vodId)
  },

  beforeDestroy() {
    this.isActiveVue = false;
    this.stop();
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
    this.stop();
  },
};
</script>
<style scoped>
input {
  border: none;
}
.video {
  position: absolute;
  left: 0;
  height: 0;
  width: 1920px;
  height: 1080px;
}
.back {
  position: absolute;
  width: 72px;
  height: 72px;
  left: 120px;
  top: 78px;
}
.restart {
  position: absolute;
  width: 72px;
  height: 72px;
  left: 232px;
  top: 78px;
}
.pb-area {
  position: absolute;
  width: 1920px;
  height: 540px;
  top: 540px;
  left: 0;
  background-image: linear-gradient(to bottom, rgba(17, 17, 17, 0), #111111);
}
.play-pause {
  position: absolute;
  width: 120px;
  height: 120px;
  left: 900px;
  top: 366px;
}
.play-time {
  position: absolute;
  right: 120px;
  top: 254px;

  font-size: 40px;
  line-height: 0.8;
  color: #eeeeee;
}
.progressbar {
  position: absolute;
  width: 1680px;
  height: 16px;
  left: 120px;
  top: 318px;
  background-color: #595959;
}
.innerbar {
  height: 16px;
  background-color: #2affcc;
}
.indicator {
  position: absolute;
  left: 0;
  width: 40px;
  height: 40px;
  margin-left: -20px;
  margin-top: -28px;
}
.movingboard {
  position: absolute;
  left: 0px;
  right: 0px;
  width: 1920px;
  height: 1080px;
  z-index: 5;
}
.active-area {
  position: absolute;
  width: 1680px;
  height: 1080px;
  left: 120px;
  bottom: 0;
  /* background-color: cornflowerblue; */
  /* opacity: 0.5; */
}
.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(100px);
  opacity: 0;
}
.exit-popup {
  position: absolute;
  left: 0;
  top: 0;
  width: 1920px;
  height: 1080px;
  text-align: center;
}
.dim {
  position: absolute;
  left: 0;
  top: 0;
  width: 1920px;
  height: 1080px;
  opacity: 0.8;
  background-color: #1e1e1e;
}
.pupup-message {
  margin-top: 432px;
  font-size: 56px;
  line-height: 1;
  text-align: center;
  color: #eeeeee;
}
button {
  width: 272px;
  height: 80px;
  background-color: #3e3e3e;
  font-size: 28px;
  color: #eeeeee;
  margin-top: 80px;
  margin-right: 27px;
  border: none;
}
button.focused {
  border: solid 4px #eeeeee;
}
.seek-left {
  position: absolute;
  left: 555px;
  top: 460px;
  width: 120px;
  height: 120px;
}
.seek-right {
  position: absolute;
  left: 1246px;
  top: 460px;
  width: 120px;
  height: 120px;
}
.seek-term {
  position: absolute;
  left: 19px;
  top: 22px;
  width: 78px;
  height: 86px;
  line-height: 86px;
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  color: #eeeeee;
}
.seek-ic {
  position: absolute;
  left: 19px;
  top: 17px;
}
.seek-term.left {
  left: 24px;
}
.seek-ic.left {
  left: 24px;
}
</style>